import { create } from 'zustand';
import type { ScreenName } from '@/types/domain';

/** Ephemeral UI/session state — never persisted (resets on reload). */
type SessionState = {
  currentScreen: ScreenName;
  idleWarningVisible: boolean;
  /** Incremented to ask any open screen-level modal to close (idle takes priority). */
  modalCloseNonce: number;
  setCurrentScreen: (screen: ScreenName) => void;
  setIdleWarningVisible: (visible: boolean) => void;
  requestCloseModals: () => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  currentScreen: 'welcome',
  idleWarningVisible: false,
  modalCloseNonce: 0,
  setCurrentScreen: (currentScreen) => set({ currentScreen }),
  setIdleWarningVisible: (idleWarningVisible) => set({ idleWarningVisible }),
  requestCloseModals: () => set((s) => ({ modalCloseNonce: s.modalCloseNonce + 1 })),
}));
